import { ref, computed, readonly, onMounted, onBeforeUnmount } from 'vue';

import useContext from './useContext';
import useCache from './useCache';

const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZÅÄÖ';
const numbers = '0123456789';

export default function () {
  const { route } = useContext();
  const { subscribe, unsubscribe } = useCache();

  let currentCacheKey = getBrandsCacheKey(route.pathname);

  const brands = ref<IBrand[]>([]);

  const brandsByAlphabet = computed(() => {
    const result: {
      letter: string;
      brands: IBrand[];
    }[] = [];

    for (const letter of alphabet) {
      result.push({ letter, brands: [] });
    }
    result.push({ letter: '0-9', brands: [] });
    result.push({ letter: '&', brands: [] });

    for (const brand of brands.value) {
      const firstLetter = brand.brandName?.charAt(0)?.toUpperCase();
      if (firstLetter) {
        const index = alphabet.includes(firstLetter)
          ? alphabet.indexOf(firstLetter)
          : numbers.includes(firstLetter)
          ? alphabet.length
          : alphabet.length + 1;

        result[index].brands.push(brand);
      } else {
        result[alphabet.length + 1].brands.push(brand);
      }
    }

    for (const item of result) {
      item.brands.sort((a: any, b: any) =>
        (a.brandName || a.slug || '').localeCompare(
          b.brandName || b.slug || '',
          'sv'
        )
      );
    }

    return result;
  });

  onMounted(() => {
    subscribe(currentCacheKey, brandsHandler, {
      immediate: true,
    });
  });

  onBeforeUnmount(() => {
    unsubscribe(currentCacheKey, brandsHandler);
  });

  function brandsHandler(brandsValue: IBrand[]) {
    brands.value = brandsValue || [];
  }

  return {
    brandsByAlphabet,
  };
}

export function getBrandsCacheKey(pathname: string) {
  return `brands:${pathname}`;
}

export interface IBrand {
  brandName: string;
  imageId: string;
  slug: string;
}
